import React from "react";

import Vacancy from "../SearchResults/Vacancy";

function DescriptiveSingleJob(props) {
  const { applyButtonPosition, applyButtonText } = props;
  return (
    <div className="d-flex flex-wrap">
      <Vacancy  applyButtonPosition={applyButtonPosition}
      applyButtonText={applyButtonText} singleJobView showHead={false} largeHeader />
    </div>
  );
}

export default DescriptiveSingleJob;
